<template>

  <form v-on:submit="Save">
    <div class="row">
      <div class="col-lg-6 col-md-6 ">
        <div class="card card-info" style="width: 100%">
          <div class="card-header">
            <h3 class="card-title">
              Manage
            </h3>
          </div>
          <div class="card-body">
            <div class="row">

              <div class="col-md-6">
                <label>FollowUp Type</label>
                <select class="form-control" v-model="followup.FollowUpID" required>
                  <option value=''>--Select FollowUp--</option>
                  <option v-for="item in followupType" v-bind:value="item.FollowUpID">{{item.Name}}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Date </label>
                <div class="input-group">
                  <input type="date" class="form-control" v-model="followup.Date" required />
                </div>
              </div>
              <div class="col-md-12">
                <label>Remarks </label>
                <div class="input-group">
                  <textarea style="width:100%" v-model="followup.Remarks" required></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer ">
            <div class=" col-md-12 text-right">
              <button class="btn btn-success " type="submit">Save</button>
              <button class="btn btn-danger " v-on:click="clear()">Clear</button>
            </div>

          </div>
        </div>
      </div>


      <div class="col-md-6 col-lg-6 ">
        <div class="card card-info" style="width: 100%">
          <div class="card-header">
            <h3 class="card-title bg-info" style="width: 100%">
              FollowUps Record
            </h3>
          </div>
          <section class="content">
            <div class="container   ">
              <div class="card-body">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table class="table table-bordered table-md table-striped" id="example">
                      <thead class="bg-green text-white">
                        <tr>
                          <td>Sr#</td>
                          <td>Type</td>
                          <td>Date</td>
                          <td>Remarks</td>
                          <td>Action</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item,index) in followUpIndex">
                          <td>{{index+1}}</td>
                          <td>{{item.follow}}</td>
                          <td>{{item.Remarks}}</td>
                          <td>{{item.Date}}</td>
                          <td>
                            <button type="button" v-on:click="editUser(item.ApplicantFollowUpsID)" class="btn btn-outline-warning" href="../"><i class="fas fa-edit"></i></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

  const axios = require('axios').default; 
  export default ({
     
    data() {
      return {
        followupType: [],
        followUpIndex:[],
        followup: { Remarks: '', Date: '', FollowUpID: '',ApplicantID:'' },
      }
    },

    created: function () { 

      this.pageLoadFollowUps();
    },

    mounted: function () {
    },

    updated: function () {
    },

    methods: {

      pageLoadFollowUps() {
        var vm = this;
        const params = new URLSearchParams(window.location.search);
        const ID = params.get('ID');
        this.followup.ApplicantID = ID;
        axios.post('/ApplicantsApi/pageLoadFollowUp?ID=' + ID)
          .then(function (res) {
            if (res.data.status) {
              vm.followupType = res.data.followupType;
              vm.followUpIndex = res.data.data;
              vm.followup.Date = res.data.date;
            }
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      editUser(ID) {
        var vm = this; 
        axios.post('/ApplicantsApi/editFollowUp?ID=' + ID)
          .then(function (res) {
            vm.followup = res.data.edit; 
          })
      },
      Save(e) {
        e.preventDefault();
        startReq();

        var vm = this;

        axios.post('/ApplicantsApi/saveFollowUps', {
          followup: vm.followup,
        })
          .then(function (res) {
            if (res.data.status) {
              toastr.success("Data Saved Successfully");
              window.location.reload();
            }
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
      Clear() {
        window.close();
      }
    }
  })
</script>



// WEBPACK FOOTER //
// src/components/ApplicantFollowUps.vue